export default __webpack_public_path__ + "static/media/alert_client_genial4.c540c184.jpeg";